import { createSelector } from 'reselect';

const selectTermData = (state) => state.termination;

export const selectTermDepartments = createSelector(
  [selectTermData],
  (termination) => {
    if (termination.data !== null) {
      return termination.data.departments;
    }

    return null;
  }
);

export const selectTermDepartment = createSelector(
  [selectTermData],
  (termination) => termination.termDepartment
);

export const selectTermPosition = createSelector(
  [selectTermData],
  (termination) => termination.termPosition
);

export const selectTermNoc = createSelector(
  [selectTermData],
  (termination) => termination.termNoc
);

export const selectTermNavitaire = createSelector(
  [selectTermData],
  (termination) => termination.termNavitaire
);

export const selectTermEmail = createSelector(
  [selectTermData],
  (termination) => termination.termEmail
);
export const selectForwardingEmail = createSelector(
  [selectTermData],
  (termination) => termination.forwardingEmail
);

export const selectTermLocation = createSelector(
  [selectTermData],
  (termination) => termination.termLocation
);

export const selectTermUber = createSelector(
  [selectTermData],
  (termination) => termination.termUber
);

export const selectTermLyft = createSelector(
  [selectTermData],
  (termination) => termination.termLyft
);

export const selectSuspendAzure = createSelector(
  [selectTermData],
  (termination) => termination.suspendAzure
);

// export const selectPositions = createSelector(
//   [selectTermData, (state, department) => department],
//   (newhire, department) => {
//     if (newhire.data !== null && department) {
//       newhire.data.departments.forEach((dep) => {
//         if (department === dep) {
//           return dep.positions.map((position) => position.title);
//         }
//       });
//     }

//     return null;
//   }
// );
